import { api } from "@/api";

export interface RoleFeature {
  feature_id: number;
  domain: string;
  feature_code: string;
  route_path: string | null;
  access: 0 | 1; // changed from boolean to 0|1 to match backend payload
  access_type: "DEFAULT" | "OPTIONAL";
}

export interface UserFeaturesResponse {
  userPrincipalName: string;
  roleCodes: string[];
  features: RoleFeature[];
}

export const getUserFeatures = (email: string) => {
  return api.getUserFeatures(email);
};

export const getUserDetails = (email: string) => {
  return api.getUserDetails(email);
};
